"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.componentWithChildren = exports.scrollToElement = exports.AnimationDiraction = exports.animateElementHeight = exports.animateScrollPosition = exports.AnimationDuration = exports.AnimationScrollProperty = void 0;
var animejs_1 = require("animejs");
var AnimationScrollProperty;
(function (AnimationScrollProperty) {
    AnimationScrollProperty["top"] = "scrollTop";
    AnimationScrollProperty["left"] = "scrollLeft";
})(AnimationScrollProperty = exports.AnimationScrollProperty || (exports.AnimationScrollProperty = {}));
var AnimationDuration;
(function (AnimationDuration) {
    AnimationDuration[AnimationDuration["Slow"] = 600] = "Slow";
    AnimationDuration[AnimationDuration["Fast"] = 300] = "Fast";
    AnimationDuration[AnimationDuration["SuperFast"] = 200] = "SuperFast";
})(AnimationDuration = exports.AnimationDuration || (exports.AnimationDuration = {}));
var animateScrollPosition = function (animatedElement, scrollProperty, scrollValue, animationDuration, onComplete) {
    var _a;
    if (animatedElement) {
        return animejs_1.default((_a = {
                targets: animatedElement
            },
            _a[scrollProperty] = scrollValue,
            _a.easing = 'linear',
            _a.duration = animationDuration,
            _a.complete = onComplete,
            _a));
    }
    return null;
};
exports.animateScrollPosition = animateScrollPosition;
var animateElementHeight = function (animatedElement, heightValue, animationDuration, onComplete) {
    if (animatedElement) {
        return animejs_1.default({
            targets: animatedElement,
            height: heightValue,
            easing: 'linear',
            duration: animationDuration,
            complete: onComplete,
        });
    }
    return null;
};
exports.animateElementHeight = animateElementHeight;
var AnimationDiraction;
(function (AnimationDiraction) {
    AnimationDiraction["Top"] = "Top";
    AnimationDiraction["Bottom"] = "Bottom";
})(AnimationDiraction = exports.AnimationDiraction || (exports.AnimationDiraction = {}));
var scrollToElement = function (element, animationObject, diraction, gutter) {
    if (gutter === void 0) { gutter = 50; }
    setTimeout(function () {
        var scrollTopValue;
        switch (diraction) {
            case AnimationDiraction.Top:
                scrollTopValue = element.current.getBoundingClientRect().top + scrollY - gutter;
                break;
            case AnimationDiraction.Bottom:
                scrollTopValue =
                    element.current.getBoundingClientRect().bottom + scrollY - (window.innerHeight - gutter);
                break;
            default:
                scrollTopValue = 0;
                break;
        }
        if (animationObject) {
            animationObject.pause();
        }
        animationObject = exports.animateScrollPosition('html, body', AnimationScrollProperty.top, scrollTopValue, AnimationDuration.Slow);
    }, 50); // change timeout 0 => 50 ms to fix animation in firefox
};
exports.scrollToElement = scrollToElement;
function componentWithChildren(Component) {
    return Component;
}
exports.componentWithChildren = componentWithChildren;
